<template>
	<modal :exibir="exibirModal" :titulo="tituloModal" :max-width="1250" class="modal-confirmacao" @close="fecharModal">
		<template #body>
			<v-container>
				<v-row class="pa-4 row-css">
					<v-col>
						<label-personalizado nome-campo="Órgão" :obrigatorioPorPadrao="true"></label-personalizado>
						<v-autocomplete
							id="combo-autocomplete-orgao"
							v-model="dataObject.orgao.data"
							name="orgao"
							dense
							:items="dataObject.orgao.items"
							placeholder="Todos"
							class="pt-0"
							:debounce-search="250"
							item-value="id"
							item-text="nome"
							return-object
						></v-autocomplete>
					</v-col>
					<v-col>
						<label-personalizado nome-campo="Exercício" :obrigatorioPorPadrao="true"></label-personalizado>
						<v-autocomplete
							id="combo-autocomplete-exercicio"
							v-model="dataObject.exercicio.data"
							name="exercicio"
							dense
							:items="dataObject.exercicio.items"
							placeholder="Todos"
							class="pt-0"
							:debounce-search="250"
							item-value="id"
							item-text="nome"
							return-object
						></v-autocomplete>
					</v-col>
					<v-col>
						<label-personalizado nome-campo="Elemento/Subelemento"></label-personalizado>
						<v-autocomplete
							id="combo-autocomplete-elemento-subelemento"
							v-model="dataObject.classificacoesDespesas.data"
							name="elemento-subelemento"
							dense
							clearable
							:items="dataObject.classificacoesDespesas.items"
							placeholder="Todos"
							class="pt-0"
							:debounce-search="250"
							item-value="id"
							item-text="nome"
							return-object
						></v-autocomplete>
					</v-col>
					<botao-primario
						v-az-auth="permissoes.dotacaoOrcamentariaOrgaosVisualizar"
						nome-botao="FILTRAR"
						@click="buscarDotacoesOrcamentariasSetup"
					></botao-primario>
				</v-row>

				<v-row dense class="px-4" v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaVisualizar">
					<v-col>
						<selecao-dotacao-orcamentaria-listagem
							v-model="dotacoesOrcamentariasSelecionadas"
							:itens="dotacoesOrcamentarias"
							:paginacao="paginacao"
							:totalItens="totalItens"
							:totalPaginas="totalPaginas"
						></selecao-dotacao-orcamentaria-listagem>
						<paginacao-tabela
							v-if="totalElements > 0"
							:page.sync="paginacaoInterna.page"
							:rows-per-page.sync="paginacaoInterna.rowsPerPage"
							:totalPaginas="totalPages"
							:totalItens="totalElements"
						></paginacao-tabela>
					</v-col>
				</v-row>
				<v-divider></v-divider>
				<v-row dense class="mt-2">
					<v-col align="right">
						<v-btn v-az-auth="permissoes.pedidoUtizacaoDotacaoOrcamentariaCriar" @click="adicionarDotacoes"
							>Salvar</v-btn
						>
					</v-col>
				</v-row>
			</v-container>
		</template>
	</modal>
</template>
<script>
import { actionTypes } from '@/core/constants'
import Modal from '@/views/components/Modal.vue'
import tabela from '@/views/mixins/tabela'
import SelecaoDotacaoOrcamentariaListagem from '@/views/pages/pedido/acessar/itens/modal/incluir-dotacao-orcamentaria/components/tabela/SelecaoDotacaoOrcamentariaListagem.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'

export default {
	name: 'modal-incluir-dotacao',
	components: { PaginacaoTabela, LabelPersonalizado, BotaoPrimario, Modal, SelecaoDotacaoOrcamentariaListagem },
	mixins: [tabela],
	props: {
		idPedido: {
			type: [String, Number],
			required: true,
		},
		tituloModal: {
			type: String,
			default: '',
		},
		exibirModal: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['fechar-modal', 'buscar-dotacoes'],
	data() {
		return {
			paginacaoInterna: this.paginacao,
			totalPages: Number(this.totalPaginas),
			totalElements: Number(this.totalItens),
			dotacoesOrcamentariasSelecionadas: [],
			dataObject: {
				orgao: {
					data: {},
					items: [],
				},
				exercicio: {
					data: {},
					items: [],
				},
				classificacoesDespesas: {
					data: {},
					items: [],
				},
			},
			dotacoesOrcamentarias: [],
		}
	},
	watch: {
		paginacaoInterna: {
			async handler() {
				await this.buscarDotacoesOrcamentariasSetup()
			},
			deep: true,
		},
	},
	async created() {
		await this.buscarClassificacoesDespesas()
		await this.buscarExercicios()
		await this.buscarOrgaos()
	},
	methods: {
		async adicionarDotacoes() {
			const itens = this.dotacoesOrcamentariasSelecionadas.map((value) => value.id)

			try {
				await this.$store.dispatch(actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.CRIAR_DOTACAO, {
					idDotacao: this.idPedido,
					itens,
				})
				this.fecharModal()
				this.dotacoesOrcamentariasSelecionadas = []
				this.mostrarNotificacaoSucesso('Dotações adicionadas com sucesso.')
				this.$emit('buscar-dotacoes')
			} catch (Err) {
				throw new Error(Err)
			}
		},
		async buscarDotacoesOrcamentariasSetup() {
			const filtros = {
				idOrgao: this.dataObject.orgao.data.id,
				exercicio: this.dataObject.exercicio.data.nome,
			}
			if (this.dataObject.classificacoesDespesas.data && this.dataObject.classificacoesDespesas.data.length) {
				filtros.idElementoSubElemento = this.dataObject.classificacoesDespesas.data.id
			}
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_PAGINADA,
				{
					idPedido: this.idPedido,
					filtros: filtros,
					paginacao: this.paginacao,
				},
			)
			this.dotacoesOrcamentarias = itens
			this.totalPages = totalPages
			this.totalElements = totalElements
		},
		async buscarOrgaos() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_ORGAOS,
				Number(this.idPedido),
			)

			this.dataObject.orgao.items = itens.map((item) => {
				return { id: item.id, nome: item.sigla }
			})
			this.dataObject.orgao.data = this.dataObject.orgao.items[0]
		},
		async buscarExercicios() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_EXERCICIOS,
			)

			if (itens.length > 0) {
				this.dataObject.exercicio.items = itens.map((item) => {
					return { id: item.exercicio, nome: `${item.exercicio}` }
				})

				this.dataObject.exercicio.data = this.dataObject.exercicio.items[0]
			}
		},
		async buscarClassificacoesDespesas() {
			const { itens } = await this.$store.dispatch(
				actionTypes.PEDIDO.DOTACAO_ORCAMENTARIA.SETUP.BUSCAR_LISTAGEM_CLASSIFICACAO_DESPESAS,
				Number(this.idPedido),
			)
			this.dataObject.classificacoesDespesas.items = itens.map((item) => {
				return { id: item.id, nome: item.descricao }
			})
		},
		fecharModal() {
			this.limparFiltros()
			this.$emit('fechar-modal')
		},
		limparFiltros() {
			this.dataObject.orgao.data = this.dataObject.orgao.items[0]
			this.dataObject.exercicio.data = this.dataObject.exercicio.items[0]
			this.dataObject.classificacoesDespesas.data = []
		},
	},
}
</script>
<style lang="stylus" scoped>
.az-template-default
	.container
		background white
.row-css
	display flex
	align-items center
</style>
